import observer from 'saddlebag-observer';

import type { CarHireEvent } from '@web-platform/global-components-types/tracking';
import type { Maybe } from '@web-platform/global-components-types/utils';

export type Message =
  | string
  | {
      [key: string]: Maybe<string> | boolean | number | Message;
    };

export type GrapplerEvent = {
  topic: 'grappler-track';
  data: {
    eventName: string;
    fullSchemaName: string;
    message: Message;
    isMiniEvent: boolean;
    consentRequired: boolean;
    messageOpts?: {
      messageGuid?: string;
    };
    microsite?: {
      name: string;
    };
  };
};

export type GAEvent = {
  topic: 'tracking-event';
  data: {
    ga: Array<{
      category: string;
      action: string;
      label?: string;
      value?: string;
    }>;
  };
};

export type EventTypes = GrapplerEvent | GAEvent | CarHireEvent;

export type TrackingEventFn = (events: EventTypes[]) => void;

export type Vertical = 'flight' | 'hotel' | 'car_hire' | 'package';

const trackEventFn = (events: EventTypes[]) => {
  events.forEach((event) => {
    observer.publish(...Object.values(event));
  });
};

export { trackEventFn };
